import {
  CapaQuotationUserNotificationFilterInput,
  useUpdateQuotationUserMutation
} from '@generated/graphql';
import { useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';
import MobileTopAppBarPresenter from '../Common/MobileTopAppBarPresenter';
import NotificationPresenter from './NotificationPresenter';

interface Props {
  refetch: () => void;
}
export default function NotificationContainer({ refetch }: Props) {
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const [updateQuotationUser] = useUpdateQuotationUserMutation();

  const onSubmit = (req: CapaQuotationUserNotificationFilterInput) => {
    updateQuotationUser({
      variables: {
        input: { notificationFilter: req }
      }
    }).then((result) => {
      refetch();
    });
  };
  return (
    <>
      {matches && <MobileTopAppBarPresenter />}
      <NotificationPresenter matches={matches} onSubmit={onSubmit} />
    </>
  );
}
